import { css } from '@emotion/core';
import { Point, TextareaPoint } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css("columns:1;@media screen and (min-width:40em){columns:2;}", Point, ",", TextareaPoint, "{padding-bottom:2.4em;}");
});